import React, { useState, useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { Button, Form, FormGroup, Label, Input, Row } from "reactstrap";
import axios from "axios";

import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";

function ConceptosCreate() {
  const { user } = useContext(AuthContext);
  const URL_CONCEPTOS = process.env.REACT_APP_URL_CONCEPTOS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const [name, setName] = useState("");
  const [text, setText] = useState(false);
  const [validaBoton, setValidaBoton] = useState(true);

  const clear = () => {
    setName("");
  };

  const saveConceptos = (event) => {
    event.preventDefault();
    setValidaBoton(false);
    axios
      .post(
        URL_CONCEPTOS,
        {
          name,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Crear Concepto",
            detalle: name,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        clear();
        Swal.fire("Good job!", "Creado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: error.response?.data?.message || "Ocurrió un error, intenta de nuevo.",
        });
        console.log(error);
        setValidaBoton(true);
      });
  };

  return (
    <>
      <div className="container">
        <h3 align="center">Crea un Concepto</h3>
        <Form onSubmit={saveConceptos}>
          <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
            <Label className="mr-sm-2">Concepto</Label>
            <Input
              type="text"
              placeholder="Nombre del Concepto"
              value={name}
              required
              onChange={(e) => {
                setName(e.target.value);
              }}
            />
          </FormGroup>
          <Row className="container">
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <div>
              <SweetAlert
                show={text}
                title="Creado con Exito"
                onConfirm={() => {
                  setText(false);
                }}
              />
            </div>
            <Button color="danger" href="/ListadoCargos">
              Regresar
            </Button>
          </Row>
        </Form>
      </div>
    </>
  );
}

export default ConceptosCreate;
